const IMAGE_LOAD_TIMEOUT_MS = 4000

function waitForImage(img: HTMLImageElement): Promise<void> {
  if (img.complete && img.naturalWidth > 0) {
    return Promise.resolve()
  }

  return new Promise((resolve) => {
    const finish = () => {
      img.removeEventListener('load', finish)
      img.removeEventListener('error', finish)
      resolve()
    }
    img.addEventListener('load', finish)
    img.addEventListener('error', finish)
    window.setTimeout(finish, IMAGE_LOAD_TIMEOUT_MS)
  })
}

export async function waitForShareCardAssets(root: HTMLElement): Promise<void> {
  const images = Array.from(root.querySelectorAll('img'))
  await Promise.all(images.map((img) => waitForImage(img)))
  await new Promise<void>((resolve) => {
    requestAnimationFrame(() => requestAnimationFrame(() => resolve()))
  })
}
